<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['add_marks_entry']">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="my-2" v-if="alevelmarks.length <= 0">
              <div class="row">
                <!-- <b-form-group class="col-md-3" label="Staff Member">
                  <v-select
                    :options="staffmembers"
                    placeholder="Select Staff"
                    @input="filterSubjects"
                    label="full_name"
                    v-model="user"
                  ></v-select>
                </b-form-group> -->
                <b-form-group class="col-md-3" label="Class">
                  <!-- class where the level is 1 -->
                  <v-select
                    :options="schoolclasses"
                    placeholder="Select Class"
                    v-model="schoolclass"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Subjects">
                  <v-select
                    :options="alevelsubjects"
                    placeholder="Select Subject"
                    @input="filterPapers"
                    v-model="subject"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    v-model="term"
                    label="name"
                    @input="filterExams"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Paper">
                  <v-select
                    :options="papers"
                    placeholder="Select Subject Paper"
                    v-model="paper"
                    label="code"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3 px-1" label="Exam">
                  <v-select
                    :options="exams"
                    placeholder="Select Exam"
                    v-model="exam"
                    label="name"
                  ></v-select>
                </b-form-group>
                <div class="col-md-3 mt-md-4 mt-2 ">
                  <b-button
                    variant="primary"
                    class="w-100"
                    @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Fetch</b-button
                  >
                </div>
              </div>
            </div>
            <div v-else>
              <div class="d-flex justify-content-between">
                <div class="">
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click="reloadPage"
                  >
                    <i class="mdi mdi-undo"></i> Reload
                  </button>
                </div>
                <div class="text-center mb-3">
                  <span class="h4"
                    >{{ schoolclass.name }} : {{ subject.name }} -
                    {{ paper.name }}, {{ term.name }} - {{ year }}
                    {{ exam.name }}</span
                  ><br />
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_photo)="data">
                    <img
                      :src="getFiles(data.item.student.student_photo)"
                      height="50"
                    />
                  </template>
                  <template #cell(student)="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }} -
                    <b class="text-danger">{{
                      data.item.student.student_id
                    }}</b>
                  </template>
                  <template #cell(mark)="data">
                    <div class="d-flex align-items-center" style="gap:5px;">
                      <input
                        :min="0"
                        :max="100"
                        :value="data.item.mark"
                        @blur="changeMark($event.target.value, data.item.id)"
                        type="number"
                        class="form-control w-70"
                      />
                      <span v-if="markStatus[data.item.id] === true">
                        <b> <i class="mdi mdi-check text-success  "></i></b>
                      </span>
                      <span v-else-if="markStatus[data.item.id] === false">
                        <i class="mdi mdi-close text-primary"></i
                      ></span>
                    </div>
                  </template>
                  <template #cell(remark)="data">
                    <textarea
                      rows="2"
                      :value="data.item.remark"
                      @blur="changeReMark($event.target.value, data.item.id)"
                      class="form-control"
                    />
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  alevelstaffloadComputed,
  alevelstaffloadMethods,
  schooltermComputed,
  schooltermMethods,
  staffmemberComputed,
  staffmemberMethods,
  userComputed,
  userMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";
export default {
  page: {
    title: "Exam Marks",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Exam Marks",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Exam Marks", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 50,
      Options: [50, 10, 150, 200, 300],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student_photo", label: "Photo", visible: true },
        { key: "student", label: "Name", visible: true },
        { key: "mark", label: "Mark", visible: true },
        { key: "remark", label: "Comments", visible: false },
      ],
      id: "",
      user: "",
      subject: "",
      term: "",
      schoolclass: "",
      exam: "",
      exams: [],
      schoolterm: "",
      paper: "",
      staffmember: "",
      remark: "",
      year: new Date().getFullYear(),
      alevelmarks: [],
      papers: [],
      alevelsubjects: [],
      schoolclasses: [],
      markStatus: {},
    };
  },
  computed: {
    ...schooltermComputed,
    ...userComputed,
    ...staffmemberComputed,
    ...alevelstaffloadComputed,
    List() {
      return this.alevelmarks.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.alevelmarks.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.alevelmarks.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.FilterClass();
    this.filterSubjects();
    this.fetchSchoolTerms();
    this.fetchUsers();
    this.fetchStaffMembers();
    this.fetchAlevelStaffloads();
    this.TotalRows = this.alevelmarks.length;
    this.isBusy = false;
    //this.term = this.schoolterms.find((option) => option.active == 1);
  },
  methods: {
    ...schooltermMethods,
    ...userMethods,
    ...staffmemberMethods,
    ...alevelstaffloadMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    reloadPage() {
      window.location.reload();
    },

    async FilterClass() {
      let url = `/findalevelclass/${this.userData.user_id}`;
      await axios.get(url).then((response) => {
        this.schoolclasses = response.data.classes;
      });
    },

    async filterSubjects() {
      let url = `/findalevelsubject/${this.userData.user_id}`;
      await axios.get(url).then((response) => {
        this.alevelsubjects = response.data.subjects;
      });
    },

    async filterPapers() {
      let url = `/findsubjectpapers/${this.subject.id}`;
      await axios.get(url).then((response) => {
        this.papers = response.data.papers;
      });
    },

    async filterExams() {
      let url = `/findschoolexam/${this.term.id},${this.year},${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.exams = response.data.exams;
      });
    },

    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    FilterData() {
      let formData = new FormData();
      formData.append("schoolterm", this.term.id);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("user", this.userData.user_id);
      formData.append("subject", this.subject.id);
      formData.append("paper", this.paper.id);
      formData.append("exam", this.exam.id);
      let url = "/addalevelmarks";
      axios.post(url, formData).then((response) => {
        this.alevelmarks = response.data.marks;
      });
    },
    async changeMark(mark, id) {
      let formData = new FormData();
      formData.append("mark", mark);
      formData.append("id", id);
      let url = "/updatealevelmarks";
      await axios
        .post(url, formData)
        .then((response) => {
          if (response.status == 200) {
            const markIndex = this.alevelmarks.findIndex(
              (item) => item.id === id,
            );
            if (markIndex !== -1) {
              this.alevelmarks[markIndex].mark = mark;
              this.$set(
                this.alevelmarks,
                markIndex,
                this.alevelmarks[markIndex],
              );
            }
            this.$set(this.markStatus, id, true);
          }
        })
        .catch((error) => {
          this.$set(this.markStatus, id, false);
          this.$swal({
            title: "Error",
            text: error.response.data.error + ". Please try again.",
            icon: "error",
          });
        });
    },
    async changeReMark(remark, id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("remark", remark);
      let url = "/updatealevelremarks";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.id = id;
        }
      });
    },
  },
};
</script>
